module.exports = __webpack_public_path__ + "static/img/6.93d57ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/sp/6.png
// module id = 5qv1
// module chunks = 0